import { useDispatch, useSelector } from 'react-redux';
import { readinessActions as A } from '../../store/readinessSlice';
import { sampleLenderMatches, BORROWER_ANON_ID } from '../../config/readinessLenders';

const OWEN_AVATAR = '/assets/owen-avatar.png';

/**
 * Anonymous lender marketplace: borrower-number banner, Owen's vetting
 * note, and sample lender cards with rate/APR/P&I/fees/timeline, status
 * pills, and Best rate / Fastest close badges. All data illustrative;
 * P&I is computed from the borrower's actual loan amount.
 */
export default function LenderMatchesScreen() {
  const dispatch = useDispatch();
  const { answers, selectedProgram } = useSelector((s) => s.readiness);
  const lenders = sampleLenderMatches(answers);

  return (
    <main data-screen-label="Lender matches" className="rdz-results-main">
      <div className="rdz-matches">
        <div>
          <button type="button" className="rdz-matches__back" onClick={() => dispatch(A.backToScore())}>
            &#8592; Back to my score
          </button>
          <div className="rdz-matches__title-row">
            <h1 className="rdz-matches__h1">Your lender matches</h1>
            <span className="rdz-matches__for">for the {selectedProgram || 'your program'}</span>
          </div>
        </div>

        <div className="rdz-anon-banner">
          <span className="rdz-anon-banner__id">You are Borrower {BORROWER_ANON_ID}</span>
          <span className="rdz-anon-banner__text">
            Lenders see your file and Readiness Score &mdash; never your name or contact info &mdash;
            until you choose to reveal it.
          </span>
        </div>

        <div className="rdz-vet-note">
          <img src={OWEN_AVATAR} alt="Owen" className="rdz-vet-note__avatar" />
          <div className="rdz-vet-note__bubble">
            I&apos;ve vetted every lender here &mdash; reviews, closing success rates, BBB standing,
            complaint history. They&apos;re competing for your file. Take your time; nothing moves
            until you say so.
          </div>
        </div>

        <div className="rdz-lenders">
          {lenders.map((l) => (
            <div className="rdz-lender" key={l.name}>
              {l.badge && <span className="rdz-float-badge">{l.badge}</span>}
              <div className="rdz-lender__id">
                <div className="rdz-lender__name">{l.name}</div>
                <div className="rdz-lender__rating">{l.rating} &middot; Owen-vetted</div>
                <div className="rdz-lender__take"><span style={{ fontWeight: 700 }}>Owen:</span> {l.take}</div>
              </div>
              <div className="rdz-lender__stats">
                <div>
                  <div className="rdz-lender__rate">{l.rate}</div>
                  <div className="rdz-lender__stat-label">{l.apr}</div>
                </div>
                <div>
                  <div className="rdz-lender__stat-val">{l.pay}</div>
                  <div className="rdz-lender__stat-label">est. P&amp;I</div>
                </div>
                <div>
                  <div className="rdz-lender__stat-val">{l.fees}</div>
                  <div className="rdz-lender__stat-label">fees</div>
                </div>
                <div>
                  <div className="rdz-lender__stat-val">{l.close}</div>
                  <div className="rdz-lender__stat-label">timeline</div>
                </div>
              </div>
              <div className="rdz-lender__right">
                <span className={'rdz-lender__status ' + (l.isOffer ? 'rdz-lender__status--offer' : 'rdz-lender__status--reviewing')}>
                  {l.status}
                </span>
                <button type="button" className="rdz-lender__cta">{l.cta}</button>
              </div>
            </div>
          ))}
        </div>

        <p className="rdz-matches__footnote">
          Sample offers for illustration. Reviewing an offer never reveals your identity &mdash; that
          only happens when you accept. LoanKnow is free for you &mdash; lenders pay to compete for
          prepared borrowers, never you.
        </p>
      </div>
    </main>
  );
}
